module.exports = __webpack_public_path__ + "static/media/etat-biberon-orange.d3c56b69.svg";